import axios from 'axios';
import { ESSENTIALS_URL } from '../auth/authUtils';

const refreshSession = async () => {
  const response = await axios.post(
    `${ESSENTIALS_URL}/availity/SessionRefreshServlet`,
    {},
    {
      withCredentials: true,
    }
  );
  return response;
};

export default refreshSession;
